export default __webpack_public_path__ + "static/media/by_11.c3a05c46.mp3";